import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { getAideIndustrieStub } from '../../../../config/aides-industrie';

export default function PretsBpifrancePage() {
  const aide = getAideIndustrieStub('prets-bpifrance');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="industrie" />;
}
